import { render, staticRenderFns } from "./RemoteDropdown.vue?vue&type=template&id=70184a05&lang=pug"
import script from "./RemoteDropdown.vue?vue&type=script&lang=js"
export * from "./RemoteDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports